export const extractTitle = (content: string) => {
  const titleRegex = /<h1>(.*?)<\/h1>/;
  const match = content.replace('\n', ' ').match(titleRegex);

  if (match) {
    const parser = new DOMParser();
    const title = parser.parseFromString(match[1], 'text/html');
    return title.body.textContent || '';
  }

  return '';
};

export const getIdFromContent = (content: string, index: number) => {
  return (
    extractTitle(content)
      .replace(/[^a-zA-Z]/g, '')
      .toLowerCase() + `_${index}`
  );
};
